import {
  sendGetHttpRequest,
  sendPostHttpRequest,
  sendHttpRequest,
} from "lib/fetcher";
import Cookies from "js-cookie";
import { DatabaseInfo, DatabaseRecordInfo } from "lib/types";

export async function getDatabasesList(query: string) {
  return sendGetHttpRequest(`/asset_tracking/databases?name=${query}`);
}

export async function addDatabase(name: string, description: string) {
  return await sendPostHttpRequest("/asset_tracking/database", {
    database: {
      name,
      description,
    },
  });
}

export async function getDatabasesRecord(
  trackingGroupId: string,
  search?: string,
) {
  return sendGetHttpRequest(
    `/asset_tracking/database/${trackingGroupId}/records?search=${search}`,
  );
}

export async function getGptImageDesc(s3Key: string) {
  return sendGetHttpRequest(
    `/asset_tracking/gen_gpt_image_data?s3Key=${s3Key}`,
  );
}

export async function updateDatabase(database: DatabaseInfo) {
  return await sendPostHttpRequest("/asset_tracking/database", {
    database,
  });
}

export async function updateRecord(data: DatabaseRecordInfo) {
  return await sendPostHttpRequest("/asset_tracking/record", {
    ...data,
  });
}

export async function deleteDatabase(id: string) {
  return await sendHttpRequest({
    url: `/asset_tracking/database/${id}`,
    method: "delete",
  });
}

export async function deleteRecord(id: string) {
  return await sendHttpRequest({
    url: `/asset_tracking/record/${id}`,
    method: "delete",
  });
}
